//关注结尾的export部分，这是外面可以调用的接口

import cryptoJS from '@/libs/util.cryptoJS.js'
import util from '@/libs/util'
import {
	Message,
	Notification
} from 'element-ui'

let ws =null

//主动创建ws连接
function wsConnect() {
	if (typeof(WebSocket) === "undefined") {
		Message.warning('您的浏览器版本过旧，部分功能可能受影响，建议升级到最新的谷歌浏览器')
		util.cookies.set('WsSupport', false) //更新ws支持标志
		util.cookies.set('WsLoginState', false) //更新ws登陆状态
	} else {
		util.cookies.set('WsSupport', true) //更新ws支持标志
		const token = util.cookies.get('token')

		//检查是否有token，没token就肯定直接踢出
		if (token) {
			//先检查是否登录好了,没登录就开始登陆
			if (!ws || ws.readyState == 0 || ws.readyState == 3) {
				//根据开发环境配置path，注意是否支持https，决定这里是ws还是wss，否则会被nginx拦截
				let path = (window.location.protocol === 'https:') ? 'wss://' : 'ws://'
				if (process.env.NODE_ENV === 'development') { //开发环境的env已经定义好ws的端口
				    path += window.location.hostname + process.env.VUE_APP_WSAPI + '?token=' + token
				} else {
				    path += window.location.hostname + ':' + window.location.port + process.env.VUE_APP_WSAPI + '?token=' + token
				}

				// 实例化socket
				ws = new WebSocket(path)
				// 重写socket连接的方法
				ws.onopen = wsOnOpen
				// 重写socket监听错误消息的方法
				ws.onerror = wsOnError
				// 重写socket接收消息的方法
				ws.onmessage = wsOnMessage
				// 重写socket关闭的方法
				ws.onclose = wsOnClose
			}

			util.cookies.set('WsLoginState', true) //更新ws登陆状态
		} else {
			if (ws && ws.readyState == 1) {
				wsClose()
			}
			util.cookies.set('WsLoginState', false) //更新ws登陆状态
			if (process.env.NODE_ENV === 'development') {
				console.log("没有token，无法登陆ws")
			}
		}
	}
}

//心跳检测
let serverTimeoutObj = null
const timeout = 540000 //9分钟一次心跳，Nginx为10分钟极限断开时间
function wsHeartCheckRestart() {
	wsHeartCheckStop()
	serverTimeoutObj = setInterval(() => {
		if (ws.readyState == 1) {
			wsSendPing();
		} else {
			if (process.env.NODE_ENV === 'development') {
				console.log("断开状态，尝试重连");
			}
			wsConnect()
		}
	}, timeout)
}
function wsHeartCheckStop() {
	clearTimeout(serverTimeoutObj)
}

//主动发送文本
function wsSend(msg) {
	if (ws) {
		let cs = JSON.stringify(cryptoJS.aesEncryptObj2Obj(msg))
		ws.send(cs)
		if (process.env.NODE_ENV === 'development') {
			console.log('发送了' + msg)
		}	
	}
}

//主动发送超轻量的Ping
function wsSendPing() {
	if (ws) {
		ws.send('ping')
		if (process.env.NODE_ENV === 'development') {
			console.log('心跳发送了Ping')
		}	
	}
}

//主动关闭连接
function wsClose() {
	if (ws) {
		ws.close()
		util.cookies.set('WsLoginState', false) //更新ws登陆状态
		if (process.env.NODE_ENV === 'development') {
			console.log("ws主动关闭连接")
		}
	}
}

//获取当前WS状态
function wsGetState() {
	if (ws) {
		console.log(ws)
	} else {
		console.log('ws不存在，是null')
	}
}


//事件：
//连接成功后触发的事件
function wsOnOpen() {
	wsHeartCheckRestart() //开始心跳检测
	if (process.env.NODE_ENV === 'development') {
		console.log("ws连接成功后")
	}
}

//连接接收信息后触发的事件
function wsOnMessage(msg) {
	wsHeartCheckRestart() //重置心跳检测
	if (msg.data !== 'pong') {
		let res = cryptoJS.aesDecryptText(JSON.parse(msg.data).data)
		Notification({
			title: res.title,
			message: res.content,
			type: res.type,
			position: 'bottom-right'
		})
	} else {
		if (process.env.NODE_ENV === 'development') {
			console.log("收到服务器端的心跳pong回复")
		}
	}
}

//连接关闭后触发的事件
function wsOnClose() {
	wsHeartCheckStop() //退出登陆，停止心跳
	if (process.env.NODE_ENV === 'development') {
		console.log("ws关闭连接后")
	}
}

//WS报错后触发的事件
function wsOnError() {
	if (process.env.NODE_ENV === 'development') {
		console.log("ws连接错误")
	}
}

//测试功能
function wsTest() {
	console.log(123)
}

export default {
	wsTest,
	//方法：
	wsConnect,//连接
	wsSend,//发送数据，传入内容
	wsClose,//关闭连接
	wsGetState,//控制台打印连接状态
}
